"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimeout = void 0;
const react_1 = require("react");
function useTimeout() {
    const timeoutIdRef = react_1.useRef();
    const cancel = react_1.useCallback(() => {
        const timeoutId = timeoutIdRef.current;
        if (timeoutId) {
            timeoutIdRef.current = undefined;
            clearTimeout(timeoutId);
        }
    }, []);
    const trigger = react_1.useCallback((callback, timeout = 0) => {
        cancel();
        timeoutIdRef.current = window.setTimeout(callback, timeout);
    }, [cancel]);
    return [trigger, cancel];
}
exports.useTimeout = useTimeout;
//# sourceMappingURL=timeout-hook.js.map